import _ from 'lodash';
import { MARKETING_CAMPAIGN_PARAMS } from 'shared/constants';
export function getMarketingParams(router, persistedSessionData) {
    var _router_query;
    var fromQuery = _.pick((_router_query = router === null || router === void 0 ? void 0 : router.query) !== null && _router_query !== void 0 ? _router_query : {}, MARKETING_CAMPAIGN_PARAMS);
    if (!_.isEmpty(fromQuery)) {
        return fromQuery;
    }
    var fromSession = _.get(persistedSessionData, 'parameters', {});
    return _.pick(fromSession, MARKETING_CAMPAIGN_PARAMS);
}
